module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M20 6c0 .25.042.486.074.726l-9.918 4.96A5.964 5.964 0 0 0 6 10a6 6 0 0 0 0 12 5.964 5.964 0 0 0 4.156-1.686l9.918 4.958c-.032.242-.074.478-.074.728a6 6 0 0 0 12 0 6 6 0 0 0-6-6 5.964 5.964 0 0 0-4.156 1.686l-9.918-4.96c.032-.24.074-.476.074-.726s-.042-.486-.074-.726l9.918-4.958A5.97 5.97 0 0 0 26 12a6 6 0 0 0 0-12 6 6 0 0 0-6 6z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/share-3.js
// module id = 1407
// module chunks = 14